const cookieOperation = {

setCookie(name,value) 
{ 
    var Days = 30; 
    var exp = new Date(); 
    exp.setTime(exp.getTime() + Days*24*60*60*1000); 
    document.cookie = name + "="+ escape (value) + ";expires=" + exp.toGMTString(); 
},

 //读取cookie
getCookie(name) 
{ 
    var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)"); 
　　 return (arr=document.cookie.match(reg))?unescape(arr[2]):null;
},
removeCookie: function (key) {
  this.setCookie(key, '', -1);
}
}

export default {
  setCookie: cookieOperation.setCookie,
  getCookie: cookieOperation.getCookie,
  removeCookie: cookieOperation.removeCookie
};



// WEBPACK FOOTER //
// ./src/service/cookie.js